import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const styles = {
  card:{
    display: 'inline-block',
  },
  cardContent: {
    padding: '30px 50px',
    display: 'flex',
    justifyContent: 'center'
  },
  textContainer: {
    textAlign: 'left',
    marginLeft: '18px'
  },
  amount: {
    fontSize: '36px',
    fontWeight: 600,
    color: '#454545'
  },
  title: {
    color: '#99a0ae'
  },
  imgContainer: {
    alignSelf: 'center'
  }
}

export default withStyles(styles)(({classes, imgSrc, title, amount, width}) => (
  <Card className={`${classes.card} card-container`} style={{ width }}>
      <CardContent className={classes.cardContent}>
        <div className={classes.imgContainer}>
          <img src={imgSrc} style={{width: 45}} />
        </div>
        <div className={classes.textContainer}>
        <h2 className={classes.amount}>{amount}</h2>
        <span className={classes.title}>{title}</span>
        </div>
      </CardContent>
  </Card>
)
);
